/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { Clinic } from './Clinic';

export type SimplePatient = {
    readonly id?: number;
    first_name: string;
    last_name?: string | null;
    middle_initial?: string | null;
    date_of_birth?: string | null;
    readonly clinic?: Clinic;
    external_patient_id?: string | null;
    /**
     * MRN / medical record number for the patient from the source system
     */
    medical_record_number?: string | null;
    /**
     * HL7 single character representation of sex: F, M, O, U, A
     */
    sex?: SimplePatient.sex | null;
    /**
     * populated by WPL PID.4 unique patient account number
     */
    has_history?: boolean;
    phone?: string | null;
}

export namespace SimplePatient {

    /**
     * HL7 single character representation of sex: F, M, O, U, A
     */
    export enum sex {
        M = 'M',
        F = 'F',
        O = 'O',
        U = 'U',
        A = 'A',
    }


}
